

class Search
{
    static find( query = '', attributes, data )
    {
        query = query.trim();
        if( query === '' )
            return data;

        const regex = new RegExp( query, 'i' );

        return data.filter( record => {
            search: for( let attribute of attributes ) {
                let data = record;
                const parts = attribute.split( '.' );
                    attribute = parts.pop();

                for( const part of parts ) {
                    if( part in record ) {
                        data = record[part];
                    } else continue search;
                }

                if( data[attribute] && data[attribute].search( regex ) !== -1 )
                    return true;
            }

            return false;
        });
    }
}

export default Search;
